module.exports = __webpack_public_path__ + "static/media/Motorola Moto 360 Women Silver + Stone Grey Closed.ac8286b9.png";